export const SIDEBAR = {
	DASHBOARD: 'Dashboard',
	TABLES_TICKETS: 'Tables & Tickets',
	TABLES_AND_TICKETS: 'Tables and Tickets',
	ATTENDEES: 'Attendees',
	AUCTION: 'Auction Items',
	COMMUNICATIONS: 'Communications',
	SETTINGS: 'Settings',
	COMMUNICATIONS_CUSTOMIZATION: 'Email Settings',
	TICKET_INVOICE: 'Ticket invoice',
	TICKET_PAYMENT_CONFIRMATION: 'Payment Confirmation',
	TABLE_UPDATE_EMAIL: 'Table Update',
	PATRON_UPDATE_EMAIL: 'Patron Update',
	AUCTION_EMAIL: 'Auction Notification',
	INVOICE_EMAIL: 'Invoice Email',
	PAYMENT_ACKNOWLEDGEMENT: 'Payment Acknowledgement',
	CONTRIBUTIONS_SUMMARY: 'Contributions Summary',
	PRINTABLES: 'Printables',
	REPORTS: 'Reports',
	EVENT_SETTINGS: 'Event settings',
	HELP_SUPPORT: 'Help & Support',
	WEBSITE_CODE: 'Auction QR Code',
	BID_SHEETS: 'Bid sheets',
	GUEST_LIST_BY_LAST_NAME: 'Guest list by last name',
	GUEST_LIST_BY_TABLE: 'Guest list by table',
	EVENT_WEBPAGE: 'Auction, FTM, & Raffle',
	WINNER_ENTRY: 'Auction Winners',
	AUCTION_CHECKOUT: 'Auction Checkout',
	FUND_THE_MISSION: 'Fund the Mission',

	ADMIN_DASHBOARD: 'Dashboard',
	ADMIN_ORGANIZATION: 'Organizations',
	ADMIN_EVENTS: 'Events',

	UPLOADED_FILE: 'Upload File',
	SELECT_HEADER_ROW: 'Select Header Row',
	MATCH_COLUMNS: 'Match Columns',
	VALIDATE_DATA: 'Validate Data',
};
